import { gql } from '@/__generated__';

const GET_USER_LIST = gql(`#graphql
  query GetUserList($input: UsersFilter, $pagination: PaginationInput, $sort: SortInput) {
    usersPagination(filter: $input, pagination: $pagination, sort: $sort) {
      items {
        id
        fullName
        email
        name
        lastnames

        phone
        callingCode
        phoneNumber
        picture
        createdAt
        lastAccess
        twoFactorAuth

        status
        mainOrganization {
          organization {
            id
            name
            verifyAuthOrgs
          }
          role {
            id
            name
          }
        }
        additionalOrganizations {
          organization {
            id
            name
            verifyAuthOrgs
          }
          role {
            id
            name
          }
        }
      }
      pageInfo {
        count
        limit
        offset
        pageNumber
        totalCount
      }
    }
  }

`);

export default GET_USER_LIST;
